// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N3c4L1jmNOM75vK3aiCQ:hover {
  background-color: rgba(248, 247, 247, 0.884) !important;
}`, "",{"version":3,"sources":["webpack://./src/componentes/Tabela/TabelaCorpo/TabelaCorpo.module.scss"],"names":[],"mappings":"AACI;EACI,uDAAA;AAAR","sourcesContent":[".rowClickable {\r\n    &:hover {\r\n        background-color: rgba(248, 247, 247, 0.884) !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export var rowClickable = `N3c4L1jmNOM75vK3aiCQ`;
export default ___CSS_LOADER_EXPORT___;
